import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "26",
  height: "26",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#DDD6FE",
      d: "M0 8a8 8 0 0 1 8-8h10a8 8 0 0 1 8 8v10a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#5B21B6",
      d: "M12.605 11.216q0 .672-.324 1.26-.312.588-.996.948-.672.36-1.704.36H8.177V17h-1.68V8.624h3.084q.972 0 1.656.336t1.02.924q.348.588.348 1.332M9.51 12.428q.696 0 1.032-.312.336-.324.336-.9 0-1.224-1.368-1.224H8.177v2.436zm10.457-1.212q0 .672-.324 1.26-.312.588-.996.948-.672.36-1.704.36h-1.404V17h-1.68V8.624h3.084q.972 0 1.656.336t1.02.924q.348.588.348 1.332m-3.096 1.212q.696 0 1.032-.312.336-.324.336-.9 0-1.224-1.368-1.224h-1.332v2.436z"
    }, null, -1)
  ]))]))
}
export default { render: render }